import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import type { MenuItemType } from 'src/app/core/models';
import { findAllParent, findMenuItem, getMenuItemFromURL } from 'src/app/helpers/menu';
import { bookingHomeMenuItems } from 'src/assets/data';
import { MenuItemWithChildrenComponent } from './components/item-with-children';
import { MenuItemComponent } from './components/item';
import { basePath, credits } from '@/app/store';
import { filter, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'horizontal-app-menu',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgbCollapseModule,
    NgbDropdownModule,
    MenuItemWithChildrenComponent,
    MenuItemComponent,
  ],
  templateUrl: './horizontal-menu.html',
  styleUrls: ['./horizontal-menu.scss'],
})
export class HorizontalAppMenuComponent implements OnInit, OnDestroy {
  @Input() showExtraPages?: boolean;
  @Input() showContactPages?: boolean;
  @Input() startBookingMenu?: boolean;
  @Input() menuClassName?: string;
  @Input() menuItems!: MenuItemType[];

  constructor(private router: Router) {}
  credits = credits;
  activeMenuItems?: string[];
  bookingHomeMenuItems = bookingHomeMenuItems;
  matchingMenuItem: MenuItemType | undefined;
  trimmedURL: string = '';
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.updateActiveFromUrl(this.router.url);

    // Recompute active item on navigation changes
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((evt: NavigationEnd) => {
        this.updateActiveFromUrl(evt.urlAfterRedirects || evt.url);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateActiveFromUrl(url: string) {
    // Keep URL trimmed relative to basePath
    this.trimmedURL = url?.replaceAll(basePath !== '' ? basePath + '/' : '', '/');
    if (this.menuItems) this.matchingMenuItem = getMenuItemFromURL(this.menuItems, this.trimmedURL);

    if (this.matchingMenuItem) {
      const activeMt = findMenuItem(this.menuItems, this.matchingMenuItem.key);
      if (activeMt) {
        this.activeMenuItems = [activeMt.key, ...findAllParent(this.menuItems, activeMt)];
      } else {
        this.activeMenuItems = undefined;
      }
    } else {
      this.activeMenuItems = undefined;
    }
  }

  getActiveClass(item: MenuItemType) {
    return this.activeMenuItems && this.activeMenuItems.includes(item.key) ? ' active' : '';
  }


}
